/* Halide & Grain — theme interactions */
(function () {
  // Dark mode toggle (persisted)
  var root = document.documentElement;
  var stored = localStorage.getItem('hg-theme');
  if (stored === 'dark') root.classList.add('dark');

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (t) {
      root.classList.toggle('dark');
      localStorage.setItem('hg-theme', root.classList.contains('dark') ? 'dark' : 'light');
    }
    var m = e.target.closest('[data-menu-toggle]');
    if (m) {
      var nav = document.getElementById('mobile-nav');
      if (nav) nav.classList.toggle('open');
    }
  });
})();
